import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Form, Input, Space, Table } from 'tdesign-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getGeoChartData,
  getGeoInList,
  getPartionGeoChartData,
  getPartitionGeoInList,
} from '@/services/topicService';
import useTable from '@/hooks/useTable';
import { renderByteRate, renderDateTime, renderNumRate } from '@/utils/common';
import ColTip from '@/components/Tip';
import SvgIcon from '@/components/SvgIcon';
import BoardModal from '@/components/Cluster/BoardModal';
import ModalHeader from '@/components/Header/Modal';
import PopupLink from '@/components/Cluster/PopupLink';

const { FormItem } = Form;

function FromRemote({ commonProps, closeDrawer, overview }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const clusterName = searchParams.get('name');
  const [boardVisible, setBoardVisible] = useState(false);
  const [currentRemoteCluster, setCurrentRemoteCluster] = useState();
  const isPartition = overview.topicPartitionCount > 0;

  const columns = [
    {
      title: '源端集群',
      colKey: 'replicationCluster',
      width: 300,
      fixed: 'left',
      cell: ({ row }) => (
        <PopupLink
          tip='跳转源端Topic'
          onClick={() => {
            closeDrawer();
            navigate(
              `/cluster/topic/list?name=${row.replicationCluster}&topic=${commonProps.topic}`,
            );
          }}
        >
          {row.replicationCluster}
        </PopupLink>
      ),
    },
    {
      title: '写入速率',
      colKey: 'rateIn',
      width: 120,
      cell: renderNumRate,
    },
    {
      title: '写入吞吐',
      colKey: 'byteIn',
      width: 120,
      cell: renderByteRate,
    },
    {
      colKey: 'getTime',
      cell: renderDateTime,
      sorter: true,
      title: <ColTip content='非实时，有分钟级延迟'>采集时间</ColTip>,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Icon type='presentation-chart-line' size={18} onClick={() => showChart(row)} />
      ),
      width: 60,
    },
  ];

  const showChart = (row) => {
    setBoardVisible(true);
    setCurrentRemoteCluster(row.replicationCluster);
  };

  const loadData = useMemoizedFn(async (params) => {
    const filter = params?.filter;
    const request = isPartition ? getPartitionGeoInList : getGeoInList;
    const { data } = await request(commonProps);

    if (filter) {
      setData(data.filter((item) => item.replicationCluster.indexOf(filter) > -1));
    } else {
      setData(data);
    }
  });

  const { setData, config, header, doRefresh, doSearch } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <Space align='center'>
        <Title>来自源端</Title>
        <FormItem name='filter'>
          <Input placeholder='请输入GEO源端集群' />
        </FormItem>
      </Space>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = (refresh) => {
    setBoardVisible(false);
    setCurrentRemoteCluster(null);
    if (refresh) {
      doRefresh();
    }
  };

  return (
    <Root>
      {header}
      <Table {...config} />
      <BoardModal
        visible={boardVisible}
        handleClose={handleClose}
        header={
          <ModalHeader tags={[clusterName, commonProps.topic, currentRemoteCluster]}>
            监控-GEO
          </ModalHeader>
        }
        getChartsData={(params) => {
          if (isPartition) {
            return getPartionGeoChartData({
              ...params,
              clusterName,
              topic: commonProps.topic,
              remoteCluster: currentRemoteCluster,
            });
          } else {
            return getGeoChartData({
              ...params,
              clusterName,
              topic: commonProps.topic,
              remoteCluster: currentRemoteCluster,
            });
          }
        }}
      />
    </Root>
  );
}

export default connect((state) => ({
  overview: state.topic.detailOverview,
}))(FromRemote);

const Root = styled.div`
  margin-top: 20px;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: #194dff;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding-left: 4px;
`;
